import './App.css';

import { Route, Routes } from 'react-router-dom';
import Home from './components/home';
import CardView from './components/cardView';
import Description from './components/description';
import EventDescription from './components/eventDescription'
import RestaurantDescription from './components/resturantDescription'
import MallDescription from './components/mallDescription';
import AttractionDescription from './components/attractionDescription'
import WalkingHikingTours from './components/walkingandhikingtour';
import NationalParks from './components/nationalParks';
import NaturalExperiences from './components/naturalexperiences';
import SeeAllPage from './components/seeAllPages';
import PlanYourJourney from './components/planYourJourney';
import EmergencyNumber from './components/emergencyNumber';
import Contact from './components/contact';
import BusDescription from './components/busesDesciption';
import NewsDescription from './components/newsDescription';
import PlaceDescription from './components/placeDescription';
import JourneyDescription from './components/journeyDescription';
import TripPlanner from './components/tripPlanner';
import MapView from './components/MapView';
import ScrollToTop from './utils/ScrollToTop';
import './css/pageHero.css';
import './css/designSystem.css';

function App() {
  return (
    <div >
     <ScrollToTop />
     
     <Routes> 
      <Route path='/' element={<Home/>} />
      <Route path='/cardView' element={<CardView/>} />
      <Route path='/description' element={<Description/>} />
      <Route path='/eventDescription' element={<EventDescription/>} />
      <Route path='/resturantDescription' element={<RestaurantDescription/>} />
      <Route path='/mallDescription' element={<MallDescription/>} />
      <Route path='/attractionDescription' element={<AttractionDescription/>} />
      <Route path='/walkingandhikingtours' element={<WalkingHikingTours/>} />
      <Route path='/naturalexperiences' element={<NaturalExperiences/>} />  
      <Route path='/nationalparks' element={<NationalParks/>} />
      <Route path="/see-all/:category" element={<SeeAllPage />} />
      <Route path='/planyourjourney' element={<PlanYourJourney/>} />
      <Route path='/trip-planner' element={<TripPlanner/>} />
      <Route path='/map-view' element={<MapView/>} />
      <Route path='/emergencyNumber' element={<EmergencyNumber/>} />
      <Route path='/contact' element={<Contact/>} />
      <Route path='/news/:slug' element={<NewsDescription/>} />
      <Route path='/places/:slug' element={<PlaceDescription/>} />
      <Route path='/journey/:slug' element={<JourneyDescription/>} />
    
      <Route path="/busDescription" element={<BusDescription />} />
    
    </ Routes>
     
    </div>
  );
}

export default App;
